import * as yup from 'yup'

const required = () => t({ id: 'web_required' })
const email = () => t({ id: 'web_veuillez_saisir_une_adresse_mail_valide' })

yup.setLocale({
  mixed: {
    default: required,
    oneOf: required,
    notOneOf: required,
    required: required,
    notType: required,
  },
  boolean: {
    isValue: required,
  },
  string: {
    email: email,
  },
})
export default yup
